import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6db1bc0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No items found", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table table-hover",
  style: {"padding-bottom":"60px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "prompt" }, "Prompt"),
    /*#__PURE__*/_createElementVNode("th", { class: "type" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "linked" }, "Linked"),
    /*#__PURE__*/_createElementVNode("th", { class: "conditional" }, "Conditional"),
    /*#__PURE__*/_createElementVNode("th", { class: "conditionalvalue" }, "Conditional Value"),
    /*#__PURE__*/_createElementVNode("th", { class: "flag" }, "Flag"),
    /*#__PURE__*/_createElementVNode("th", { class: "flagvalue" }, "Flag Value"),
    /*#__PURE__*/_createElementVNode("th", { class: "required" }, "Required"),
    /*#__PURE__*/_createElementVNode("th", { class: "photo" }, "Photo"),
    /*#__PURE__*/_createElementVNode("th", { class: "notes" }, "Notes"),
    /*#__PURE__*/_createElementVNode("th", { class: "delete" })
  ])
], -1))
const _hoisted_8 = { class: "prompt draggable-item" }
const _hoisted_9 = { class: "type draggable-item" }
const _hoisted_10 = { class: "linked draggable-item" }
const _hoisted_11 = { class: "conditional draggable-item" }
const _hoisted_12 = { class: "conditionalvalue draggable-item" }
const _hoisted_13 = { class: "flag draggable-item" }
const _hoisted_14 = { class: "flagvalue draggable-item" }
const _hoisted_15 = { class: "required draggable-item" }
const _hoisted_16 = { class: "photo draggable-item" }
const _hoisted_17 = { class: "notes draggable-item" }
const _hoisted_18 = { class: "delete draggable-item" }
const _hoisted_19 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { Compliancequestion, QuestionWrapper, QuestionOption, SelectOption } from "@/models";
import { snakeCase } from "lodash";

import { Container, Draggable } from "vue-dndrop";
import MidTermQuestionModal from "@/components/modals/MidTermQuestionModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Compliance',
  setup(__props) {

const midTermQuestionModalEdit = ref(null);

const store = useStore();
const toasted = useToast();

const compliancelist = computed(() => store.getters['customerdictionary/compliancelist'] as Compliancequestion[]);

const typeOptions = computed(() => {
  return [
    { name: "Select List", slug: "select" },
    { name: "Text", slug: "text" },
    { name: "Text Area", slug: "textarea" },
    { name: "Heading", slug: "heading" },
    { name: "Sub Heading", slug: "subheading" },
  ];
});

const linkOptions = computed(() => {
  return compliancelist.value.map((question) => {
    return { name: question.prompt, slug: question.slug } as SelectOption;
  });
});

const getDisplayType = (val: string) => {
  const found = typeOptions.value.find((option) => option.slug == val);
  return found ? found.name : val;
};

const getDisplayBoolean = (val: any) => val ? "Yes" : "No";

const getDisplayLink = (val: string) => val ? "Yes" : "No";

const edit = (question: Compliancequestion) => {
  setSelectedQuestion(question);
    {
      let wrapper = new QuestionWrapper();
      wrapper.slug = question.slug;
      wrapper.prompt = question.prompt;
      let typeOpt: SelectOption | undefined = typeOptions.value.find(
        (option) => option.slug == question.questionType
      );
      if (typeOpt) {
        wrapper.type = {
          name: typeOpt.name,
          slug: typeOpt.slug,
        };
      }

      wrapper.options = question.optionList.map((option) => {
        let qOptions = new QuestionOption({});
        qOptions.slug = snakeCase(option);
        qOptions.value = option;
        return qOptions;
      });

      let linkOpt: SelectOption | undefined = linkOptions.value.find(
        (option) => option.slug == question.link
      );
      if (linkOpt) {
        wrapper.link = {
          name: linkOpt.name,
          slug: linkOpt.slug,
        };
      }

      wrapper.conditional = question.conditional;
      wrapper.linkconditionvalue = question.linkconditionvalue;
      wrapper.flag = question.flag;
      wrapper.flagvalue = question.flagvalue;
      wrapper.required = question.required;
      wrapper.photo = question.photo;
      wrapper.notes = question.notes;
      wrapper.fixflocategory = question.fixflocategory;
      wrapper.fixflosubcategory = question.fixflosubcategory;

      setQuestionWrapper(wrapper);
    }
    const modal = midTermQuestionModalEdit.value;
    modal.show();
};

const remove = async (question: Compliancequestion) => {
  try {
    // Use confirmation modal logic
    await store.commit('customerdictionary/removeFromComplianceList', question);
    toasted.success("Question deleted");
  } catch (err: any) {
    // Display error
  }
};

const onDrop = (dragResult: any) => {
  store.dispatch('customerdictionary/setComplianceList', applyDrag(compliancelist.value, dragResult));
};

const applyDrag = (
  list: Compliancequestion[],
  dragResult: any
): Compliancequestion[] => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return list;

  const result = [...list];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};
const setSelectedQuestion = (question: Compliancequestion) => {
  store.commit('customerdictionary/setSelectedQuestion', question);
};

const setQuestionWrapper = (questionwrapper: QuestionWrapper) => {
  store.commit('customerdictionary/setQuestionWrapper', questionwrapper);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!compliancelist.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Container), {
            onDrop: onDrop,
            tag: "tbody",
            "lock-axis": "y",
            "drag-class": "opacity-ghost",
            "animation-duration": 500
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compliancelist.value, (question) => {
                return (_openBlock(), _createBlock(_unref(Draggable), {
                  key: question.slug,
                  tag: "tr"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(question.prompt), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(getDisplayType(question.questionType)), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(getDisplayLink(question.link)), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(getDisplayBoolean(question.conditional)), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(getDisplayBoolean(question.linkconditionvalue)), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(getDisplayBoolean(question.flag)), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(question.flagvalue), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(getDisplayBoolean(question.required)), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(getDisplayBoolean(question.photo)), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(getDisplayBoolean(question.notes)), 1),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-danger",
                          onClick: [
                            ($event: any) => (remove(question)),
                            _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          ]
                        }, _hoisted_22, 8, _hoisted_20),
                        _createElementVNode("button", {
                          class: "btn btn-outline-primary",
                          onClick: [
                            ($event: any) => (edit(question)),
                            _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                          ]
                        }, _hoisted_25, 8, _hoisted_23)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])),
    _createVNode(MidTermQuestionModal, {
      id: `midterm-question-modal-edit`,
      ref_key: "midTermQuestionModalEdit",
      ref: midTermQuestionModalEdit,
      operation: 'edit'
    }, null, 512)
  ]))
}
}

})